import service from '@/assets/service'
import {mapState} from 'vuex'
import {typeOf} from '@zjy/zjy-ui/lib/utils/dom'
import {capitalize, clone, processParams, isIE} from '@/assets/utils'
import { getCookie, setCookie } from '@/assets/utils/CommonUtil'
import _ from 'lodash'
import ManageService from '@/assets/service/manage'
import {previewHrefUrl} from '@/assets/js/config'
export default {
  data () {
    return {
      previewIcon: {},
      iconListKey: 0,
      user: {},
      bimFaceLoading: require('../../static/images/bimface/bimloading.gif'),
      bimFaceError: require('../../static/images/bimface/error.png')
    }
  },
  computed: {
    ...mapState({
      userInfoReady: state => state.user.userInfoReady,
      workspace: state => state.space.workspace,
      workspaceReady: state => state.space.workspaceReady
    })
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo){
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    this.loadImg(this.bimFaceLoading)
    this.loadImg(this.bimFaceError)
    this.getButtons()
  },
  methods: {
    // 没有共享空间权限提示
    confirmPermission (message = '', submitFn) {
      if (message) {
        this.$confirm({
          message,
          type: 'noPermission',
          width: 420,
          noCancelBtn: true,
          submitText: '确定',
          submit: () => {
            if (typeof submitFn === 'function') {
              submitFn()
            }
          }
        })
      } else {
        ManageService.getRole({token: getCookie('ZJYTOKEN'), users: [2]}).then(res => {
          let data = res.data || []
          let adminName = []
          data.forEach(item => {
            adminName.push((item.username || '') + (item.name ? '(' + (item.name || '') + ')' : ''))
          })
          // 员工 无权下载 企业空间文件
          this.$confirm({
            // message: `您没有共享空间权限，请联系负责人${adminName.join('或')}获取权限。`,
            message: '您没有共享空间权限，请联系负责人获取权限。',
            type: 'noPermission',
            width: 420,
            noCancelBtn: true,
            submitText: '确定',
            submit: () => {
              if (typeof submitFn === 'function') {
                submitFn()
              }
            }
          })
        }).catch(() => {
          this.$message.error('获取负责人信息失败')
        })
      }
    },
    // 1. 获取当前页面 预览按钮列表
    getButtons () {
      // console.log('----- getButtons -----')
      // console.log(this.userInfoReady)
      // console.log(this.workspaceReady)
      if (this.userInfoReady && this.workspaceReady) {
        const handleResult = (list) => {
          list.forEach((item) => {
            if (item.suffix && typeOf(item.suffix) === 'String') {
              const suffixList = item.suffix.split(',')
              item.linkUrl = encodeURIComponent(item.linkUrl)
              item.suffix = capitalize(item.suffix, true, true)
              suffixList.forEach((name) => {
                this.$set(this.previewIcon, capitalize(name, true, true), Object.assign(clone(item), {suffix: name}))
              })
            }
          })
          // console.log(this.previewIcon)
          // console.log('-----------------------------')
          this.iconListKey++
        }
        const list = require('assets/js/previewButtons.js').default || []
        const copyList = JSON.parse(JSON.stringify(list))
        handleResult(copyList)
        // const params = {
        //   // gray: '',
        //   userType: this.user.userType,
        //   menuId: this.nowMenu.id
        // }
        // service.space.getOperateButtons(params).then((data) => {
        //   // console.log(data)
        //   // console.log('=======================')
        //   if (+data.code === 200) {
        //     const list = data.data || []
        //     handleResult(list)
        //   }
        // })
      }
    },
    // 2. 预览 item: 查看对象(行数据); icon: 当前按钮对象; view: 是否只是查看(预览) 主要针对.pano 文件编辑编辑按钮是编辑、点击右键菜单、文件名称、图标是预览
    filePreview: _.debounce(function (item, icon, viewAction, {moduleName = '', projectId = 0, isRecord = false, recordWorkspaceId}) {
      const tabletype = moduleName || this.tabletype
      // name 文件名称 fileType 文件类型 fileId 文件id
      const {name, fileType, fileId} = item || {}
      const {linkParameter, suffix, windowName} = icon || {}
      debugger
      const iconSuffix = capitalize(suffix, true, true)
      let nowPreviewType = ''
      let workspaceId = ''
      let workspaceType = 0
      let path = item.path
      let projectIOType = '个人'
      const fileTypeName = +item.fileType === 1 ? '计价' : (+item.fileType === 2 ? '计量' : '')
      path = path.replace(/\/{2}/, '/')
      switch (tabletype) {
        case 'personalList':
          workspaceId = this.workspace[1] || '' // 个人空间
          workspaceType = 1
          projectIOType = '个人'
          break
        case 'companyList': // 共享空间
          workspaceId = this.workspace[2] || ''
          workspaceType = 2
          projectIOType = '企业-共享'
          break
        case 'projectList': // 项目库
          workspaceId = this.workspace[3] || ''
          workspaceType = 3
          projectIOType = '企业-项目'
          break
        case 'recordList': // 备案库
          workspaceId = recordWorkspaceId
          workspaceType = 4
          projectIOType = '企业-项目'
          break
        default:
      }
      let spaceId = workspaceId // 空间id 同 workspaceId
      let spaceType = workspaceType // 空间类型 同 workspaceType
      let href = window.location.href
      // const hrefPrefix = window.location.origin
      const hrefPrefix = previewHrefUrl || window.location.origin
      const homeHref = href // 主页地址
      // const userType = this.user.userType // 用户类型
      const fileName = name // 文件路径 同 name
      const filePath = path // 文件路径 同 path
      const CBDToken = getCookie('CBDToken') || '' // CBDToken
      const fileSuffix = iconSuffix // 文件后缀
      let viewToken = '' // viewToken
      let viewId = fileId // viewId
      if (tabletype === 'projectList' && !projectId) {
        projectId = this.$route.params.id
      }
      // 能提供的参数字典表 包含的参数外面同时存在相应的 如 dic.name 外面同时有 name
      const dic = {
        name,
        fileName,
        fileType,
        path,
        CBDToken,
        fileTypeName,
        fileId,
        workspaceId,
        spaceId,
        spaceType,
        homeHref,
        // userType,
        workspaceType,
        fileSuffix,
        projectId,
        viewToken,
        viewId,
        filePath,
        projectIOType
      }

      /* 处理预览文件前 发送请求参数 start */
      let linkParameters = [] // 预览跳页 之后地址 参数列表
      if (linkParameter !== undefined && typeOf(linkParameter) === 'String') {
        linkParameters = linkParameter.split(',')
      }
      const nowParams = {windowName}
      const fileParams = {workspaceId}
      if (fileId !== '' && fileId !== undefined){
        fileParams.fileId = fileId
      } else {
        fileParams.filePath = filePath
      }
      fileParams.projectId = projectId
      // // 备案
      // if (/\/database\/data\/record\//.test(window.location.href) || isRecord) {
      //   fileParams.projectId = window.recordedProjectId || projectId
      // }

      // 是否有预览权限校验
      if (!item.permission) {
        // 共享空间
        if (workspaceType === 2) {
          this.confirmPermission()
          return
        }
      }
      // 是否已加密校验
      if (item.fileProperties && +item.fileProperties.isEncrypt === 1) {
        // 已加密
        this.$message.info('暂不支持此类文件预览!')
        return
      }
      // 上海地区的 预算工程 暂不支持预览 GBQ5
      // if (item.fileProperties && item.fileProperties.region === '上海' && ['gbq5', 'gbq6'].includes(iconSuffix)) {
      //   this.$message.info('暂不支持本地区工程预览，正在开发中，敬请期待~')
      //   return
      // }

      /* 处理预览文件前 发送请求参数 end */

      // 1. 预览图片、excel、word、pdf 前 先获取文件地址
      const previewFile = (type) => {
        if (type === 'image' && item.length >= 10 * 1024 * 1024) {
          this.$message.info(' 图片大于10M，请先下载再查看!')
          return
        }
        console.log(fileParams)
        service.space.previewFile(fileParams, isRecord).then((data) => {
          console.log(data.data)
          if (+data.code === 200 && data.data) {
            previewAll(data.data, type)
          }
        })
      }

      // 2. 跳转到其他系统预览
      const previewModel = () => {
        // 模型操作記錄
        this.addOperationRecords(9, item)
        let canPreview = true
        switch (iconSuffix) {
          case 'gdq': // 装饰工程
          case 'dwg': // 图纸
          case 'pano': // 全景图
          case 'gtj': // 土建工程
          case 'gtjjy': // 土建工程-高教版
          case 'gtjxs': // 土建工程-高教版
          case 'gqi4': // 安装工程
          case 'gqijy': // 安装工程-高教版
          case 'gqixs': // 安装工程-高教版
            canPreview = this.checkBrowser(item, icon)
            break
          default:
        }
        canPreview && previewAll()
      }

      // 3. 所有预览统一走到这里
      const previewAll = (previewUrl, lastFileType) => {
        console.log(previewUrl)
        console.log('-----------------')
        if (previewUrl) {
          if (lastFileType === 'image') {
            this.$viewImage({
              zIndex: 2001,
              // index: 1, // 默认展示第几章图 0开始
              images: [previewUrl]
            })
          } else {
            dic.previewUrl = previewUrl
          }
        }
        if (lastFileType === 'image') { return }
        linkParameters.forEach((key) => {
          nowParams[key] = dic[key] === undefined ? '' : dic[key]
        })
        let url = decodeURIComponent(icon.linkUrl)
        console.dir(url)
        if (!/^http[s]?:\/\//.test(url)) {
          url = url.replace(/[/]{2,}/g, '/')
          url = url.replace(/^\//, '')
          // 如果是相对路径 则拼上 地址前缀
          url = hrefPrefix + '/' + url
        }
        const reg = /\$\{([^}]+)\}/
        let matchedStr = reg.exec(url)
        while (matchedStr && matchedStr.length > 1) {
          url = url.replace(new RegExp('\\$\\{' + matchedStr[1] + '\\}'), encodeURIComponent(encodeURIComponent(dic[matchedStr[1]])))
          matchedStr = reg.exec(url)
        }
        url = processParams(url, nowParams)
        let windowName = icon.windowName || ''
        if (viewAction !== 2) {
          if (iconSuffix === 'pano') {
            windowName = 'target_pano_view'
            url = url.substring(0, url.indexOf('vr_edit'))
            url += `vr/viewId/${encodeURIComponent(dic.viewId)}/spaceId/${encodeURIComponent(dic.spaceId)}/filename/${encodeURIComponent(dic.fileName)}?windowName=target_pano_view`
          }
        }
        console.dir('url: ' + url)
        switch (+icon.openType) {
          case 1: // 新窗口打开
            if (!windowName){
              window.open(url, '_blank')
            } else {
              if (nowPreviewType === 'office') {
                // 解决 IE 浏览器不能正常浏览 文件名称超长的 office文件的问题 将文件名称放到cookie中
                if (isIE()) {
                  let previewFileName = 'previewFileName_' + new Date().getTime()
                  setCookie(previewFileName, fileName)
                  url = url.substring(0, url.indexOf('filename%25'))
                  url += '&previewFileName=' + previewFileName
                }
                window.open(url)
              } else {
                let recordedProjectId = window.recordedProjectId || projectId || ''
                if (windowName === 'target_gbq5') {
                  window.open(url + '&privilege=' + window.privilege + '&recordedProjectId=' + recordedProjectId, windowName)
                } else {
                  window.open(url + '&recordedProjectId=' + recordedProjectId, windowName)
                }
              }
            }
            break
          default:
        }
      }

      switch (iconSuffix) {
        case 'gsc5':
        case 'gsh5':
        case 'gpb5':
        case 'gsc6':
        case 'gsh6':
        case 'gpb6':
        case 'gsc7':
        case 'gsh7':
        case 'gpb7':
        case 'gsc6jy':
        case 'gsh6jy':
        case 'gpb6jy':
        case 'gsc6xs':
        case 'gsh6xs':
        case 'gpb6xs':
          this.addOperationRecords(8, item)
          previewAll()
          break
        case 'gpv5':
        case 'gbq5':
        case 'gpv6':
        case 'gbq6':
        case 'gpv7':
        case 'gbq7':
        case 'gpv6jy':
        case 'gbq6jy':
        case 'gpv6xs':
        case 'gbq6xs':
          previewAll()
          break
        case 'gif':
        case 'jpeg':
        case 'jpg':
        case 'bmp':
        case 'png':
          previewFile('image')
          break
        case 'pdf':
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
          previewFile('office')
          nowPreviewType = 'office'
          break
        default:
          if (iconSuffix === 'pano' && item.length > 10 * 1024 * 1024) {
            this.$message.info({
              message: '图片大于10M，请先下载再查看!'})
            return
          }
          if (linkParameters.indexOf('viewToken') > -1 || icon.linkUrl.indexOf('viewToken') > -1) {
            // 模型解析错误
            const modelError = () => {
              this.$confirm({
                type: 'imageAndText',
                imageSrc: this.bimFaceError,
                tips: '模型解析错误！',
                imageWidth: 140, // 图片宽度
                width: 360, // 弹窗宽度
                submit: (data) => {
                  console.log(data)
                },
                noCancelBtn: true
              })
            }
            const getViewToken = () => {
              service.space.getViewToken(fileParams).then((data) => {
                if (+data.code === 200 && data.data) {
                  viewId = data.data.viewId
                  viewToken = data.data.viewToken
                  dic.viewId = viewId
                  dic.viewToken = viewToken
                  previewModel()
                } else {
                  modelError()
                }
              })
            }
            if (['gdq', 'gqi4', 'gqijy', 'gqixs'].includes(iconSuffix)) {
              const modelStateParams = {
                workspaceId,
                filePath: path,
                fileId
              }
              const onResolving = () => {
                this.$confirm({
                  type: 'imageAndText',
                  imageSrc: this.bimFaceLoading,
                  tips: '正在为您解析模型',
                  tipsRed: '文件上传<span class="bim_wait_date">30分钟</span>后即可查看',
                  imageWidth: 110, // 图片宽度
                  textWrapperStyle: 'padding-top: 0;',
                  width: 360, // 弹窗宽度
                  submit: (data) => {
                    console.log(data)
                  },
                  noCancelBtn: true
                })
              }
              service.space.getModelState(modelStateParams).then((data) => {
                console.log(data)
                if (+data.code === 200 && data.data && data.data.status) {
                  switch (data.data.status) {
                    case 'success':
                      getViewToken()
                      break
                    case 'failed':
                      modelError()
                      break
                    default:
                      onResolving()
                  }
                } else if (+data.code === 100106) {
                  // 个人空间模型正在解析时  分享到 企业共享空间 在企业共享空间 预览模型 也提示正在 解析
                  onResolving()
                } else {
                  modelError()
                }
              }).catch((e) => {
                console.log(e)
                modelError()
              })
            } else {
              getViewToken()
            }
          } else {
            previewModel()
          }
      }
    }, 600),
    // 2. 预览 item: 查看对象(行数据); icon: 当前按钮对象; view: 是否只是查看(预览) 主要针对.pano 文件编辑编辑按钮是编辑、点击右键菜单、文件名称、图标是预览
    preview: _.debounce(function (item, icon, viewAction) {
      console.log(viewAction)
      console.log(item)
      console.log(icon)
      // return
      const iconSuffix = capitalize(icon.suffix, true, true)
      let nowPreviewType = ''
      let workspaceId = ''
      let spaceId = ''
      let workspaceType = 0
      let spaceType = ''
      // 路径重复！
      // let path = item.parentPath + item.path
      let path = item.path
      let projectIOType = '个人'
      const fileTypeName = +item.fileType === 1 ? '计价' : (+item.fileType === 2 ? '计量' : '')
      path = path.replace(/\/{2}/, '/')
      switch (this.tabletype) {
        case 'personalList':
          workspaceId = this.workspace[1] || '' // 个人空间
          workspaceType = 1
          projectIOType = '个人'
          break
        case 'companyList': // 共享空间
          workspaceId = this.workspace[2] || ''
          workspaceType = 2
          projectIOType = '企业-共享'
          break
        case 'projectList': // 项目库
          workspaceId = this.workspace[3] || ''
          workspaceType = 3
          projectIOType = '企业-项目'
          break
        default:
      }
      // console.log(iconSuffix)
      // console.log(item)
      spaceId = workspaceId // 空间id 同 workspaceId
      spaceType = workspaceType // 空间类型 同 workspaceType
      // path = encodeURIComponent(path) // 文件路径
      let href = window.location.href
      // const hrefPrefix = href.substring(0, href.indexOf(this.$route.path))
      // const hrefPrefix =  window.location.origin
      const hrefPrefix = previewHrefUrl || window.location.origin
      const homeHref = href // 主页地址
      // const userType = this.user.userType // 用户类型
      const name = item.name // 文件名称
      const fileName = item.name // 文件路径 同 name
      const fileType = item.fileType // 文件类型
      const filePath = path // 文件路径 同 path
      const fileId = item.fileId // 文件id
      const CBDToken = getCookie('CBDToken') || '' // CBDToken
      const fileSuffix = iconSuffix // 文件后缀
      let projectId = 0 // 项目id
      let viewToken = '' // viewToken
      let viewId = fileId // viewId
      if (this.tabletype === 'projectList') {
        projectId = this.$route.params.id
      }
      // 咱能提供的参数 字典表 包含的参数外面同时存在相应的 如 dic.name 外面同时有 name。 别问我为什么 你会懂的 ...
      const dic = {
        name,
        fileName,
        fileType,
        path,
        CBDToken,
        fileTypeName,
        fileId,
        workspaceId,
        spaceId,
        spaceType,
        homeHref,
        // userType,
        workspaceType,
        fileSuffix,
        projectId,
        viewToken,
        viewId,
        filePath,
        projectIOType
      }

      /* 处理预览文件前 发送请求参数 start */
      let linkParameters = [] // 预览跳页 之后地址 参数列表
      if (icon.linkParameter !== undefined && typeOf(icon.linkParameter) === 'String') {
        linkParameters = icon.linkParameter.split(',')
      }
      const nowParams = {
        windowName: icon.windowName
      }
      const fileParams = {workspaceId}
      if (fileId !== '' && fileId !== undefined){
        fileParams.fileId = fileId
      } else {
        fileParams.filePath = filePath
      }
      // 备案
      if (/\/database\/data\/record\//.test(window.location.href)) {
        fileParams.projectId = window.recordedProjectId
      }
      /* 处理预览文件前 发送请求参数 end */

      // 1. 预览图片、excel、word、pdf 前 先获取文件地址
      const previewFile = (type) => {
        // console.log(item)
        // console.log(icon)
        if (type === 'image' && item.length >= 10 * 1024 * 1024) {
          this.$message.info(' 图片大于10M，请先下载再查看!')
          return
        }
        service.space.previewFile(fileParams).then((data) => {
          console.log(data.data)
          if (+data.code === 200 && data.data) {
            previewAll(data.data, type)
          }
        })
      }

      // 2. 跳转到其他系统预览
      const previewModel = () => {
        // 模型操作記錄
        this.addOperationRecords(9, item)
        let canPreview = true
        // console.dir(JSON.stringify(icon))
        switch (iconSuffix) {
          case 'gdq': // 装饰工程
          case 'dwg': // 图纸
          case 'pano': // 全景图
          case 'gtj': // 土建工程
          case 'gtjjy': // 土建工程-高教版
          case 'gtjxs': // 土建工程-高教版
          case 'gqi4': // 安装工程
          case 'gqijy': // 安装工程-高教版
          case 'gqixs': // 安装工程-高教版
            canPreview = this.checkBrowser(item, icon)
            break
          default:
        }
        // console.log(canPreview)
        // console.log('11111111111111111111')
        if (canPreview) {
          previewAll()
        }
      }

      // 3. 所有预览统一走到这里
      const previewAll = (previewUrl, lastFileType) => {
        console.log(previewUrl)
        console.log('-----------------')
        if (previewUrl) {
          if (lastFileType === 'image') {
            this.$viewImage({
              zIndex: 2001,
              // index: 1, // 默认展示第几章图 0开始
              images: [previewUrl]
            })
          } else {
            dic.previewUrl = previewUrl
          }
        }
        if (lastFileType === 'image') { return }
        linkParameters.forEach((key) => {
          nowParams[key] = dic[key] === undefined ? '' : dic[key]
        })
        let url = decodeURIComponent(icon.linkUrl)
        console.dir(url)
        if (!/^http[s]?:\/\//.test(url)) {
          url = url.replace(/[/]{2,}/g, '/')
          url = url.replace(/^\//, '')
          // 如果是相对路径 则拼上 地址前缀
          url = hrefPrefix + '/' + url
        }
        const reg = /\$\{([^}]+)\}/
        let matchedStr = reg.exec(url)
        while (matchedStr && matchedStr.length > 1) {
          url = url.replace(new RegExp('\\$\\{' + matchedStr[1] + '\\}'), encodeURIComponent(encodeURIComponent(dic[matchedStr[1]])))
          matchedStr = reg.exec(url)
        }
        url = processParams(url, nowParams)
        let windowName = icon.windowName || ''
        if (viewAction !== 2) {
          if (iconSuffix === 'pano') {
            windowName = 'target_pano_view'
            url = url.substring(0, url.indexOf('vr_edit'))
            url += `vr/viewId/${encodeURIComponent(dic.viewId)}/spaceId/${encodeURIComponent(dic.spaceId)}/filename/${encodeURIComponent(dic.fileName)}?windowName=target_pano_view`
          }
        }
        console.dir('url: ' + url)
        switch (+icon.openType) {
          case 1: // 新窗口打开
            if (!windowName){
              window.open(url, '_blank')
            } else {
              if (nowPreviewType === 'office') {
                // 解决 IE 浏览器不能正常浏览 文件名称超长的 office文件的问题 将文件名称放到cookie中
                if (isIE()) {
                  let previewFileName = 'previewFileName_' + new Date().getTime()
                  setCookie(previewFileName, fileName)
                  url = url.substring(0, url.indexOf('filename%25'))
                  url += '&previewFileName=' + previewFileName
                }
                window.open(url)
              } else {
                let recordedProjectId = window.recordedProjectId ? window.recordedProjectId : ''
                if (windowName === 'target_gbq5') {
                  window.open(url + '&privilege=' + window.privilege + '&recordedProjectId=' + recordedProjectId, windowName)
                } else {
                  window.open(url + '&recordedProjectId=' + recordedProjectId, windowName)
                }
              }
            }
            break
          default:
        }
      }
      // 是否有 预览权限 校验
      if (!item.permission) {
        switch (workspaceType) {
          case 2:
            this.confirmPermission('', () => {
            })
            // this.$confirm({
            //   message: '您没有企业空间权限，请联系管理员获取权限。',
            //   tips: '管理员账号为：' + this.user.adminAccount,
            //   type: 'noPermission',
            //   width: 420,
            //   submit: () => {
            //   },
            //   cancel: () => {
            //     this.$store.commit('user/SET_TO_LOGIN_AS_ADMIN')
            //   },
            //   submitText: '确定',
            //   cancelText: '我是管理员'
            // })
            break
          default:
        }
        return
      }
      // 是否已加密 校验
      if (item.fileProperties && +item.fileProperties.isEncrypt === 1) {
        // 已加密
        this.$message.info('暂不支持此类文件预览!')
        return
      }
      // 上海地区的 预算工程 暂不支持预览 GBQ5
      // if (item.fileProperties && item.fileProperties.region === '上海' && (iconSuffix === 'gbq5' || iconSuffix === 'gbq6')) {
      //   this.$message.info('暂不支持本地区工程预览，正在开发中，敬请期待~')
      //   return
      // }
      switch (iconSuffix) {
        case 'gsc5':
        case 'gsh5':
        case 'gpb5':
        case 'gsc6':
        case 'gsh6':
        case 'gpb6':
        case 'gsc7':
        case 'gsh7':
        case 'gpb7':
        case 'gsc6jy':
        case 'gsh6jy':
        case 'gpb6jy':
        case 'gsc6xs':
        case 'gsh6xs':
        case 'gpb6xs':
          this.addOperationRecords(8, item)
          previewAll()
          break
        case 'gpv5':
        case 'gbq5':
        case 'gpv6':
        case 'gbq6':
        case 'gpv7':
        case 'gbq7':
        case 'gpv6jy':
        case 'gbq6jy':
        case 'gpv6xs':
        case 'gbq6xs':
          previewAll()
          break
        case 'gif':
        case 'jpeg':
        case 'jpg':
        case 'bmp':
        case 'png':
          previewFile('image')
          break
        case 'pdf':
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
          previewFile('office')
          nowPreviewType = 'office'
          break
        default:
          if (iconSuffix === 'pano' && item.length > 10 * 1024 * 1024) {
            this.$message.info({
              message: '图片大于10M，请先下载再查看!'})
            return
          }
          if (linkParameters.indexOf('viewToken') > -1 || icon.linkUrl.indexOf('viewToken') > -1) {
            // 模型解析错误
            const modelError = () => {
              this.$confirm({
                type: 'imageAndText',
                imageSrc: this.bimFaceError,
                tips: '模型解析错误！',
                imageWidth: 140, // 图片宽度
                width: 360, // 弹窗宽度
                submit: (data) => {
                  console.log(data)
                },
                noCancelBtn: true
              })
            }
            const getViewToken = () => {
              service.space.getViewToken(fileParams).then((data) => {
                if (+data.code === 200 && data.data) {
                  viewId = data.data.viewId
                  viewToken = data.data.viewToken
                  dic.viewId = viewId
                  dic.viewToken = viewToken
                  previewModel()
                } else {
                  modelError()
                }
              })
            }
            if (['gdq', 'gqi4', 'gqijy', 'gqixs'].includes(iconSuffix)) {
            // if (iconSuffix === 'gdq' || iconSuffix === 'gqi4') {
              const modelStateParams = {
                workspaceId,
                filePath: path,
                fileId
              }
              const onResolving = () => {
                this.$confirm({
                  type: 'imageAndText',
                  imageSrc: this.bimFaceLoading,
                  tips: '正在为您解析模型',
                  tipsRed: '文件上传<span class="bim_wait_date">30分钟</span>后即可查看',
                  imageWidth: 110, // 图片宽度
                  textWrapperStyle: 'padding-top: 0;',
                  width: 360, // 弹窗宽度
                  submit: (data) => {
                    console.log(data)
                  },
                  noCancelBtn: true
                })
              }
              service.space.getModelState(modelStateParams).then((data) => {
                console.log(data)
                if (+data.code === 200 && data.data && data.data.status) {
                  switch (data.data.status) {
                    case 'success':
                      getViewToken()
                      break
                    case 'failed':
                      modelError()
                      break
                    default:
                      onResolving()
                  }
                } else if (+data.code === 100106) {
                  // 个人空间模型正在解析时  分享到 企业共享空间 在企业共享空间 预览模型 也提示正在 解析
                  onResolving()
                } else {
                  modelError()
                }
              }).catch((e) => {
                console.log(e)
                modelError()
              })
            } else {
              getViewToken()
            }
          } else {
            previewModel()
          }
      }
    }, 600),
    // 这个回头会删掉 写在这里 是为了在 管理后台 款速配置操作按钮 用的
    pUrls () {
      // let str = '/model-browsing/#/browsing/filename/${name}/path/${path}/spaceType/${spaceType}/projectIOType/${projectIOType}/fileId/${fileId}' // 浏览 GTJ

      // let str1 = '/deco-browsing/#/deco-cloud/viewId/${viewId}/viewToken/${viewToken}/spaceId/${workspaceId}/projectId/${projectId}/fileId/${fileId}/spaceType/${spaceType}/homeHref/${homeHref}/filename/${name}' // 浏览 GDQ
      // let str2 = '/deco-browsing/#/dwg/viewId/${viewId}/viewToken/${viewToken}/filename/${name}' // 预览图纸 .dwg
      // let str3 = '/gqi-browsing/#/gqi-browsing/viewId/${viewId}/viewToken/${viewToken}/filename/${name}/path/${path}/spaceType/${spaceType}'  // 浏览 GQI4
      // let str4 = '/deco-browsing/#/vr_edit/viewId/${viewId}/spaceId/${spaceId}/userType/${userType}/homeHref/${homeHref}/filename/${name}' // 编辑全景图 .pano
      // let str41 = '/deco-browsing/#/vr/viewId/${viewId}/spaceId/${spaceId}/filename/${name}' // 预览全景图 .pano
      // let str5 = '/deco-browsing/#/video/viewId/${viewId}/spaceId/${spaceId}/filename/${name}' // 预览 mp4
      //
      //
      // let str6 = '/#/preview/${name}?CBDToken=${CBDToken}&previewUrl=${previewUrl}&name=${name}' // 预览word
      // let str7 = '/#/preview/${name}?CBDToken=${CBDToken}&previewUrl=${previewUrl}&name=${name}' // 预览excel
      // let str8 = '/#/preview/${name}?CBDToken=${CBDToken}&previewUrl=${previewUrl}&name=${name}' // 预览PDF
      //
      // let str9 = '/#/preview/${name}?CBDToken=${CBDToken}&previewUrl=${path}&fileName=${name}&spaceType=${workspaceType}' // 预览 .gsc5 .gpv5 .gsh5 .gpb5
      // let str10 = '/#/preview/${name}?path=${path}&fileType=${fileType}&workspaceId=${workspaceId}' // 预览 .gbq5
      // let str11 = '/#/preview/gbq5?shareToken=DzxgYW&fileId=d86e1934c7a5454aaa8665683124fb9e&fileType=2300&jsonToken=aaaaa&fileName=%E6%9C%89%E9%A2%9C%E8%89%B2%E6%A0%87%E6%B3%A8.GBQ5' // 预览 分享的 .gbq5
    },
    // 浏览器校验
    checkBrowser (item) {
      let canPreview = true
      const ua = navigator.userAgent.toLowerCase()
      let isWx = false
      let isQQ = false
      let qqInstallted = false
      // qq 浏览器
      if (ua.indexOf('qqbrowser') > -1) {
        isQQ = true
        if (ua.indexOf('qqbrowser') > -1) {
          // qq内置浏览器 提示用默认浏览器打开
          // $('.qq_browser').show();
          qqInstallted = true
        }
      }
      // 微信浏览器
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        isWx = true
      }
      // console.log(item)
      if ((isQQ && !qqInstallted) || isWx || isIE()){
        canPreview = false
        this.$confirm({
          message: '当前浏览器不支持模型查看，请您使用Google浏览器查看模型。',
          type: 'downloadChrome',
          width: 400,
          showHeader: true,
          showClose: true,
          submit: (data) => {
            window.open('https://www.google.cn/chrome/')
          },
          submitText: '下载Google浏览器',
          noCancelBtn: true
        })
      }
      return canPreview
    }
  },
  watch: {
    'userInfoReady': function () {
      if (this.userInfoReady) {
        this.getButtons()
      }
    },
    'workspaceReady': function () {
      if (this.workspaceReady) {
        this.getButtons()
      }
    }
  }
}
